// extracted by mini-css-extract-plugin
export default {"spinnerOverlay":"Spinner_spinnerOverlay__Z4YDT","spinner":"Spinner_spinner__Z6H3Z","spin":"Spinner_spin__Q9zsz"};